import { Column, ColumnType } from "../../components/datatable/interfaces";
import { ProjectsStorageModel } from "./ProjectsStorage";

const tableColumns: Column[] = [
  {
    key: "name",
    name: "general.name",
    type: ColumnType.String,
    sortable: true,
    filterable: true,
  },
  {
    key: "lead",
    name: "general.projects.lead",
    type: ColumnType.String,
    sortable: true,
    filterable: true,
  },
  {
    key: "jobsCount",
    name: "general.projects.list-header.jobs-added",
    type: ColumnType.Number,
    sortable: true,
    filterable: true,
  },
];

export const ProjectsSummaryStorageModel = ProjectsStorageModel.named(
  "ProjectsSummaryStorageModel"
).views(() => ({
  get columns() {
    return tableColumns;
  },
}));
